module.exports = __webpack_public_path__ + "media/bootstrap-icons/trophy-fill-c07e9c79.svg";